import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-unattendedrequest-card',
  templateUrl: './helpbutton-reports-unattendedrequest-card.component.html',
  styleUrls: ['./helpbutton-reports-unattendedrequest-card.component.scss']
})
export class HelpbuttonReportsUnattendedrequestCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
